var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6562 51.0312H37.1562L36.0938 19.5H45.7188L44.6562 51.0312ZM40.9062 55.9688C42.4271 55.9688 43.6458 56.4167 44.5625 57.3125C45.5 58.2083 45.9688 59.3542 45.9688 60.75C45.9688 62.125 45.5 63.2604 44.5625 64.1562C43.6458 65.0521 42.4271 65.5 40.9062 65.5C39.4062 65.5 38.1875 65.0521 37.25 64.1562C36.3333 63.2604 35.875 62.125 35.875 60.75C35.875 59.375 36.3333 58.2396 37.25 57.3438C38.1875 56.4271 39.4062 55.9688 40.9062 55.9688Z",
    fill: "#F2C94C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38.5,
    stroke: "#F2C94C",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attention-icon.771a362193b20986ee6de1df7cc55a3b.svg";
export { ForwardRef as ReactComponent };